import BedroomsLinearSelectorFilterSubscriber from "./subscribers/BedroomsLinearSelectorFilterSubscriber";
import dom from "../../../common/ts/core/dom";
import location from "../../../common/ts/core/location";
import {serviceContainer} from "./SerpServiceContainerFactory"
import GoogleDisplay from "./components/googleDisplay";
import {TrovitSerpData} from "./TrovitPageData";
import {connect} from "../../../common/ts/connect";
import {ListingsSubscriber} from "./subscribers/ListingsSubscriber";
import FiltersModalSubscriber from "./subscribers/FiltersModalSubscriber";
import SortBySelectorSubscriber from "./subscribers/SortBySelectorSubscriber";
import PriceRangeSelectorSubscriber from "./subscribers/PriceRangeSelectorSubscriber";
import AreaRangeSelectorSubscriber from "./subscribers/AreaRangeSelectorSubscriber";
import BathroomsLinearSelectorFilterSubscriber from "./subscribers/BathroomsLinearSelectorFilterSubscriber";
import PropertyTypesSelectorSubscriber from "./subscribers/PropertyTypesSelectorSubscriber";
import CitiesSelectorSubscriber from "./subscribers/CitiesSelectorSubscriber";
import RegionsSelectorSubscriber from "./subscribers/RegionsSelectorSubscriber";
import {ToggleDescription} from "./subscribers/ToggleDescription";
import {ListingVisited} from "./subscribers/ListingVisited";
import SimilarListingsSubscriber from "./subscribers/SimilarListingsSubscriber";
import {
    ConsentCookieIsAlreadySetEvent,
    PageLoadedEvent,
} from "../../../common/ts/events/Events";
import {EventBus} from "../../../common/ts/events/EventBus";
import {FiltersSubscriber} from "./subscribers/FiltersSubscriber";
import CityAreasSelectorSubscriber from "./subscribers/CityAreasSelectorSubscriber";
import {ListingsFilteringResponseSubscriber} from "./subscribers/ListingFilteringResponseSubscriber";
import ClearAllFormFiltersSubscriber from "./subscribers/ClearAllFormFiltersSubscriber";
import ShowResultsSubscriber from "./subscribers/ShowResultsSubscriber";
import AjaxFilteringActivated from "../AjaxFilteringActivated";
import Sticky from "./components/Sticky";
import PointsOfCapture from "./components/retention/pointsOfCapture/PointsOfCapture";
import {GoogleOneTapSubscriber} from "./subscribers/GoogleOneTapSubscriber";
import webPushNotifications from "./webpush-notifications/wpnManager";
import ConsentSubscriber from "./subscribers/ConsentSubscriber";
import {isDidomiConsentCookieSet, isConsentCookieSet} from "../../../common/ts/components/core/ConsentCookie";
import ClearAllFiltersAndReloadSubscriber from "./subscribers/ClearAllFiltersAndReloadSubscriber";
import PageGallery from "../../../common/ts/components/PageGallery";
import {LocalStorageWrapper} from "../../../common/ts/LocalStorageWrapper";
import {MarketStatsStyles} from "../../../common/ts/components/charts/MarketStatsChart";
import {MarketStatsChartVersion, SerpMarketStatsChart} from "../../../common/ts/components/charts/SerpMarketStatsChart";
import {isMobileDevice} from "../../../mitula/ts/device";

const isAjaxFilteringActivated = new AjaxFilteringActivated();

const eventBus: EventBus = EventBus.getInstance();
eventBus.subscribeWithId(
    PageLoadedEvent.TYPE,
    {
        id: 'trovit-serp-page-loaded-subscriber',
        callback: (event) => {
            const pageData: TrovitSerpData = (event as PageLoadedEvent<TrovitSerpData>).payload;
            connect(() => {
                dom.init();
                location.init();

                serviceContainer.get(ListingsSubscriber.name).init(pageData);

                serviceContainer.get(SimilarListingsSubscriber.name).init(pageData);

                let propertyTypesSelectorSubscriber: PropertyTypesSelectorSubscriber = serviceContainer.get(PropertyTypesSelectorSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    propertyTypesSelectorSubscriber = serviceContainer.get(PropertyTypesSelectorSubscriber.name + '.ajax')
                }
                propertyTypesSelectorSubscriber.init(pageData);

                let bedroomsLinearSelectorFilterSubscriber: BedroomsLinearSelectorFilterSubscriber = serviceContainer.get(BedroomsLinearSelectorFilterSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    bedroomsLinearSelectorFilterSubscriber = serviceContainer.get(BedroomsLinearSelectorFilterSubscriber.name + '.ajax')
                }
                bedroomsLinearSelectorFilterSubscriber.init(pageData);

                let bathroomsLinearSelectorFilterSubscriber: BathroomsLinearSelectorFilterSubscriber = serviceContainer.get(BathroomsLinearSelectorFilterSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    bathroomsLinearSelectorFilterSubscriber = serviceContainer.get(BathroomsLinearSelectorFilterSubscriber.name + '.ajax')
                }
                bathroomsLinearSelectorFilterSubscriber.init(pageData);

                serviceContainer.get(FiltersModalSubscriber.name).init(pageData);

                serviceContainer.get(SortBySelectorSubscriber.name).init(pageData);

                let priceRangeSelectorSubscriber: PriceRangeSelectorSubscriber = serviceContainer.get(PriceRangeSelectorSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    priceRangeSelectorSubscriber = serviceContainer.get(PriceRangeSelectorSubscriber.name + '.ajax')
                }
                priceRangeSelectorSubscriber.init(pageData);

                let areaRangeSelectorSubscriber: AreaRangeSelectorSubscriber = serviceContainer.get(AreaRangeSelectorSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    areaRangeSelectorSubscriber = serviceContainer.get(AreaRangeSelectorSubscriber.name + '.ajax')
                }
                areaRangeSelectorSubscriber.init(pageData);

                let regionsSelectorSubscriber: RegionsSelectorSubscriber = serviceContainer.get(RegionsSelectorSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    regionsSelectorSubscriber = serviceContainer.get(RegionsSelectorSubscriber.name + '.ajax')
                }

                regionsSelectorSubscriber.init(pageData);

                let citiesSelectorSubscriber: CitiesSelectorSubscriber = serviceContainer.get(CitiesSelectorSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    citiesSelectorSubscriber = serviceContainer.get(CitiesSelectorSubscriber.name + '.ajax')
                }
                citiesSelectorSubscriber.init(pageData);

                let cityAreaSelectorSubscriber: CityAreasSelectorSubscriber = serviceContainer.get(CityAreasSelectorSubscriber.name)
                if (isAjaxFilteringActivated.isEnabled(pageData.device)) {
                    cityAreaSelectorSubscriber = serviceContainer.get(CityAreasSelectorSubscriber.name + '.ajax')
                }
                cityAreaSelectorSubscriber.init(pageData);

                serviceContainer.get(GoogleDisplay.name).init();
                serviceContainer.get(ToggleDescription.name).init();
                serviceContainer.get(ListingVisited.name).init();
                serviceContainer.get(FiltersSubscriber.name).init(pageData);
                serviceContainer.get(ListingsFilteringResponseSubscriber.name).init();
                serviceContainer.get(ShowResultsSubscriber.name).init(pageData);
                serviceContainer.get(ClearAllFormFiltersSubscriber.name).init(pageData);
                serviceContainer.get(ClearAllFiltersAndReloadSubscriber.name).init(pageData);
                serviceContainer.get(Sticky.name).init();
                serviceContainer.get(PointsOfCapture.name).init(pageData);
                serviceContainer.get(GoogleOneTapSubscriber.name).init(pageData);
                if (pageData.isRolledOutCountry) {
                    webPushNotifications.init(pageData);
                }
                serviceContainer.get(ConsentSubscriber.name).init(pageData);
            });

            if (isDidomiConsentCookieSet() || isConsentCookieSet()) {
                eventBus.emit(new ConsentCookieIsAlreadySetEvent());
            }
            new PageGallery(".swiper-container:has(.swiper-wrapper)");
            new LocalStorageWrapper().setItem("lastSerpUrl", decodeURIComponent(window.location.href));
            initMarketStats(isMobileDevice(pageData.device));
        }


    }
)
function initMarketStats(isMobile: boolean) {
    const marketStatsStyles: MarketStatsStyles = {
        lineColor: '#0080FF',
        fillColor: '#0080FF',
        axisBorderColor: '#4A4A4A',
        scalesLabelColor: '#7A7A7A',
        tickPadding: isMobile ? 0 : 10,
        tooltipTitleFontSize: isMobile ? 10 : 14,
        tooltipBodyFontSize: isMobile ? 12 : 16,
        chartType: 'bar',
        pointRadius: isMobile ? 5 : 8,
        pointColor: '#FFFFFF',
        pointHoverColor: '#0080FF',
        xAxisRotation: isMobile ? 90 : false,
        yAxisRotation : false,
        barThickness: isMobile ? 12 : 32,
        barBorderRadius: isMobile ? 60 : 8,
    };

    new SerpMarketStatsChart().init(marketStatsStyles, '.js-market-stats-chart', MarketStatsChartVersion.NO_POINTS);
}